<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div
            class="text-sm text-center copyright text-muted"
            :class="this.$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            Tomate©
            {{ new Date().getFullYear() }} made with love by
            <a
              href="https://humantrends.es"
              class="font-weight-bold"
              target="_blank"
              >Human Trends</a
            >
            Ethic Intelligence.
          </div>
        </div>
        <div class="col-lg-6">
          <ul
            class="nav nav-footer justify-content-center justify-content-lg-end"
          >
            <li class="nav-item">
              <a
                href="https://humantrends.es"
                class="nav-link text-muted"
                target="_blank"
                >Human Trends</a
              >
            </li>
            <li class="nav-item">
              <a
                href="https://www.humantrends.es/emailai-privacy-policy"
                class="nav-link text-muted"
                target="_blank"
                >Privacy policy</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
};
</script>
